import React from 'react';
import {makeStyles} from 'tss-react/mui';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import {
   PtrnAccion,
   PtrnBotonPosicion,
   PtrnColors,
   PtrnIcons,
   PtrnTipoAccion
} from '../../patronTypes';
import CampoEditable from '../CampoEditable';
import PtrnAccionButton from '../PtrnAccionButton';
import {PtrnEstilosGenerales} from '../../patronUtils';
import {PtrnReportePdfExcelProps} from './PtrnReportePdfExcelMiniTypes';
import PtrnTitulo from '../PtrnTitulo';
import {PtrnEstadoSimpleProps, PtrnMainContentProps} from '../../patronProps';
import {LocalizacionDefault} from '../../../../common/localizacionApp';
import PtrnTituloGridHeader from '../PtrnTituloGridHeader';

const useStyles = makeStyles<number>()((theme, maxHeightVhMain) => {
   return {
      containerMainContent: PtrnEstilosGenerales.containerMainContent(maxHeightVhMain)
   };
});

function PtrnReportePdfExcelMini({
   //interfaz
   camposConfig,
   titulo,
   ptrnRef,
   onClickExcel,
   onClickPdf,
   onClickCancelar,
   maxHeightVhMain,
   localizacion,
   //estado
   onBlurComponente,
   onChangeState,
   setState,
   state
}: PtrnReportePdfExcelProps & PtrnEstadoSimpleProps & PtrnMainContentProps) {
   const {classes} = useStyles(maxHeightVhMain);
   const idCompPrefix = 'ptrn-form-base';

   const accionCancel = {
      label: 'Cancelar',
      fn: onClickCancelar,
      icon: PtrnIcons.cancel,
      descripcion: 'Reinicia los campos a sus valores por defecto'
   };
   const accionPdf: PtrnAccion = {
      label: LocalizacionDefault.acciones.pdf.label,
      icon: PtrnIcons.pdf,
      tipo: PtrnTipoAccion.positiva,
      fn: () => {
         if (onClickPdf) {
            onClickPdf({...state});
         }
      },
      descripcion: LocalizacionDefault.acciones.pdf.descripcion
   };
   const accionExcel: PtrnAccion = {
      label: LocalizacionDefault.acciones.excel.label,
      icon: PtrnIcons.excel,
      tipo: PtrnTipoAccion.positiva,
      fn: () => {
         if (onClickExcel) {
            onClickExcel({...state});
         }
      },
      descripcion: LocalizacionDefault.acciones.excel.descripcion
   };
   return (
      <Grid
         id={`${idCompPrefix}-grid-root`}
         container
         direction="column"
         justifyContent="space-between"
         spacing={2}
      >
         <PtrnTituloGridHeader idPrefix={idCompPrefix} titulo={titulo} />

         <Grid
            id={`${idCompPrefix}-grid-body-flds`}
            className={classes.containerMainContent}
            container
            item
            xs={12}
            spacing={1}
            alignItems="flex-start"
         >
            {camposConfig.map((curr, inx) => {
               return (
                  <CampoEditable
                     key={curr.name}
                     campoConfig={curr}
                     camposData={state}
                     value={state[curr.name] !== undefined ? state[curr.name].valor : state}
                     onChange={onChangeState}
                     onBlur={onBlurComponente}
                     ptrnRef={ptrnRef}
                  />
               );
            })}
         </Grid>
         <Grid
            id={`${idCompPrefix}-grid-footer`}
            container
            alignItems="center"
            justifyContent="space-between"
            spacing={1}
            item
            xs={12}
         >
            {accionCancel && (
               <Grid item xs={3}>
                  <PtrnAccionButton
                     name={`${idCompPrefix}-btn-cancel`}
                     accion={{...accionCancel, tipo: PtrnTipoAccion.neutra}}
                     camposData={state}
                     ptrnRef={ptrnRef}
                     fullWidth
                  />
               </Grid>
            )}
            {onClickExcel && (
               <Grid item xs={3}>
                  <PtrnAccionButton
                     name={`${idCompPrefix}-btn-excel`}
                     accion={{...accionExcel, tipo: PtrnTipoAccion.positiva}}
                     camposData={state}
                     color={PtrnColors.success}
                     posicionIcono={PtrnBotonPosicion.inicio}
                     ptrnRef={ptrnRef}
                     fullWidth
                  />
               </Grid>
            )}
            {onClickPdf && (
               <Grid item xs={3}>
                  <PtrnAccionButton
                     name={`${idCompPrefix}-btn-pdf`}
                     accion={{...accionPdf, tipo: PtrnTipoAccion.positiva}}
                     camposData={state}
                     color={PtrnColors.error}
                     posicionIcono={PtrnBotonPosicion.inicio}
                     ptrnRef={ptrnRef}
                     fullWidth
                  />
               </Grid>
            )}
         </Grid>
      </Grid>
   );
}

export default PtrnReportePdfExcelMini;
